var _defs, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#b3ddee;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-4{stroke:#0090b9;stroke-width:2px;}.cls-1{opacity:0.5;}.cls-3{fill:#fff;}.cls-4{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-5{fill:#0090b9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.07,79.76v7.33l-39,.1L96,82.11V81.5l0-1.7a18.11,18.11,0,0,1,7.72-7.28l.16-.08a56.77,56.77,0,0,1,6.72-2.82l.25-1.23a12,12,0,0,1-3.17-5.86s-3.38-1.77-1.11-5.67c0,0-1.86-11.27,9-11.21s8.94,11.19,8.94,11.19,2.56,3-.93,5.81c0,0-1.23,5.08-3.28,5.69l.21,1.22a56.72,56.72,0,0,1,6.1,2.7l.11,0C130.39,74.23,134.47,76.93,135.07,79.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110,79.76v7.33l-39,.1-.06-5.08V81.5l0-1.7a18.14,18.14,0,0,1,7.71-7.28l.17-.08a56.53,56.53,0,0,1,6.71-2.82l.26-1.23a12,12,0,0,1-3.18-5.86s-3.37-1.77-1.11-5.67c0,0-1.86-11.27,9-11.21s8.94,11.19,8.94,11.19,2.55,3-.94,5.81c0,0-1.22,5.08-3.28,5.69l.22,1.22a56.12,56.12,0,0,1,6.09,2.7s.08,0,.12,0C105.27,74.23,109.36,76.93,110,79.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.16,86.86v9L6.5,95.94l-.07-6.21V89l0-2.07A22.07,22.07,0,0,1,15.81,78l.21-.1a70.29,70.29,0,0,1,8.19-3.44L24.52,73c-2.22-2.1-3.85-6-3.87-7.15,0,0-4.12-2.16-1.35-6.92,0,0-2.28-13.75,11-13.68S41.22,58.88,41.22,58.88s3.12,3.7-1.14,7.1c0,0-1.49,6.2-4,7l.26,1.49a70.42,70.42,0,0,1,7.44,3.28l.14.08C48.44,80.11,53.43,83.41,54.16,86.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.8,86.86v9l-47.65.13-.07-6.21V89l0-2.07c2.63-4.14,4.9-6.53,9.41-8.88l.21-.1a70.29,70.29,0,0,1,8.19-3.44L97.16,73c-2.22-2.1-3.85-6-3.87-7.15,0,0-4.12-2.16-1.36-6.92,0,0-2.27-13.75,11-13.68s10.91,13.65,10.91,13.65,3.12,3.7-1.14,7.1c0,0-1.5,6.2-4,7l.27,1.49a71.46,71.46,0,0,1,7.44,3.28l.14.08C121.08,80.11,126.07,83.41,126.8,86.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.27,14.34s-3,18-25,25"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.27,14.34s-2.8,16.8-22.83,24.25"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.99 33.99 41.98 38.35 46.33 40.36 43.63 41.35 39.27 39.34 41.29 34.99 43.99 33.99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.24,13.87s3,18,25,25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.24,13.87S67,30.68,87.08,38.13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82.18 39.9 86.54 37.88 84.52 33.53 87.22 34.52 89.24 38.88 84.89 40.89 82.18 39.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.9307ade6e39d41a70b7b1afe3d326d88.svg";
export { ForwardRef as ReactComponent };